import Link from '@src/components/base/Link';
import { cn } from '@src/components/ui';

import SidebarItem from './SidebarItem';


/** Active nav row per DESIGN.md `nav-item-active`: the signature indigo→violet
 * gradient left-edge bar plus a faint primary surface tint, primary icon, ink
 * label. The row is already `relative`, so the bar is a `before:` pseudo. */
const activeClassName = cn(
  'bg-primary-soft font-semibold text-ink [&_svg]:text-primary',
  'before:absolute before:left-0 before:top-1/2 before:h-[18px] before:w-[3px]',
  'before:-translate-y-1/2 before:rounded-full before:bg-brand-gradient',
);

function SidebarNavItem(props) {
  const { exact = true, ...restProps } = props;
  return (
    <SidebarItem
      as={Link}
      activeOptions={{ exact }}
      activeProps={{ className: activeClassName }}
      {...restProps}
    />
  );
}

SidebarNavItem.displayName = 'SidebarNavItem';
export default SidebarNavItem;
